import { pushToDataLayer } from '../dataLayer'
import type { IResultSearch } from './types'

const doneEventResultSearch = (props: IResultSearch): void => {
  const { quantity, query } = props

  pushToDataLayer({
    eventAction: 'sucesso',
    eventCategory: 'produto:catalogo:busca',
    eventLabel: `${query}:${quantity}`,
  })
}

const doneEventSearchProduct = (key: string): void => {
  pushToDataLayer({
    eventAction: 'sucesso',
    eventCategory: 'produto:cadastrar:busca',
    eventLabel: key,
  })
}

const doneEventSearchMetrics = (key: string, action: string): void => {
  pushToDataLayer({
    eventAction: action,
    eventCategory: 'produto:catalogo:metricas',
    eventLabel: key,
  })
}

export { doneEventResultSearch, doneEventSearchProduct, doneEventSearchMetrics }
